import { SystemStyleObject } from "@mui/system/styleFunctionSx/styleFunctionSx";
import { Theme, alpha } from "@mui/material";

export const flexContainer: SystemStyleObject<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  flexDirection: { xs: "column", sm: "row" },
};

export const copyrightWrapper: SystemStyleObject<Theme> = {
  py: "15px",
};

export const flexContainerWrapper: SystemStyleObject<Theme> = {
  borderTop: theme => `1px solid ${alpha(theme.palette.common.black, 0.1)}`,
  bgcolor: "background.secondary",
  py: { xs: "40px", sm: "48px", md: "64px" },
};
export const logoWrapper: SystemStyleObject<Theme> = {
  display: "flex",
  flexDirection: "column",
  mb: { xs: "10px", sm: "24px" },
};
export const linksWrapper: SystemStyleObject<Theme> = { maxWidth: 740, width: "100%" };

export const langSelect: SystemStyleObject<Theme> = {
  backgroundColor: "common.white",
  "& .MuiOutlinedInput-notchedOutline.MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};
